import { DocumentData } from "@angular/fire/firestore";
import { MenuDistributionSettings } from "./menu.distribution.model";
import { MenuDistributionType } from "./menu.distribution.enum";

export class MenuDistributionSettingsBuilder {
  private _type: MenuDistributionType;
  private _labels: string[];

  constructor() {
    this.default();
  }

  public get type(): MenuDistributionType {
    return this._type;
  }

  public set type(type: MenuDistributionType) {
    this._type = type;
  }

  public get labels(): string[] {
    return this._labels;
  }

  public set labels(strs: string[]) {
    this._labels = strs;
  }

  public addLabel(str: string) {
    this._labels.push(str);
  }
  
  public removeLabel(index: number) {
    this._labels.splice(index, 1);
  }

  private default(): void {
    this._type = MenuDistributionType.Employee;
    this._labels = [];
  }
  public edit(
    settings: MenuDistributionSettings
  ): MenuDistributionSettingsBuilder {
    this._type = settings.type;
    this._labels = settings.labels;
    return this;
  }
  public load(data: DocumentData): MenuDistributionSettingsBuilder {
    this._type = data.type;
    this._labels = data.labels;
    return this;
  }
  public build(): MenuDistributionSettings {
    return new MenuDistributionSettings(this);
  }
  public toJSON = () => ({ type: this._type, labels: this._labels });
}
